import { University } from "@/types/generated/DifcamWebTypes";

import { BaseService } from "./BaseService";

export class UniversityService extends BaseService {
  getUniversity(code: string): Promise<University> {
    return this.get<University>(`/university/${code}`);
  }
}
